import Header from './Header';

document.addEventListener('DOMContentLoaded', () => {
  const $header = document.getElementById('header');
  if (!$header) {
    return;
  }
  const header = new Header($header);
  header.mount();
});
